module.exports = __webpack_public_path__ + "img/admin-bg.c94d2ad3.jpeg";